import { createFileRoute, Navigate } from '@tanstack/react-router'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { ActiveEnergyManagement } from '@/features/ActiveManagement/components/ActiveEnergyManagement/ActiveEnergyManagement'

export const Route = createFileRoute(
    '/_layout/active-management/active-energy-management'
)({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <ActiveEnergyManagement />
            </RoleRestrictedContent>
        </>
    )
}
